import * as tslib_1 from "tslib";
import { Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { map } from 'rxjs/operators/map';
import { Image } from './models/image';
import { RestService, ObjectWithLinks, RelationTypes } from '../../common';
var ExtendzFileUploadComponent = /** @class */ (function () {
    function ExtendzFileUploadComponent(rest, snackBar) {
        this.rest = rest;
        this.snackBar = snackBar;
        this.images = [];
        this.allowMultiple = false;
    }
    ExtendzFileUploadComponent.prototype.ngOnInit = function () {
        if (this.property.relationShipType === RelationTypes.MULTIPLE) {
            this.allowMultiple = true;
        }
        this.updateImageList();
    }; // ngOnInit()
    ExtendzFileUploadComponent.prototype.updateImageList = function () {
        var _this = this;
        if (this.item[this.property.name]) {
            var imageNames = this.item[this.property.name];
            // Single image
            if (typeof imageNames == 'string') {
                this.images = [new Image(this.getFileUrl(imageNames))];
            }
            else {
                var list = imageNames;
                list.forEach(function (imageName) {
                    _this.images.push(new Image(_this.getFileUrl(imageName), false));
                });
            }
        } // if
    }; // updateImageList
    ExtendzFileUploadComponent.prototype.uploadFile = function (file, image) {
        var _this = this;
        var formData = new FormData();
        formData.append(this.property.name, file);
        var rest$ = this.rest.http
            .post(this.getUrl(), formData)
            .pipe(map(function (fileNames) {
            if (_this.property.relationShipType != RelationTypes.MULTIPLE) {
                _this.item[_this.property.name] = fileNames[0];
            }
            else {
                // Add existing
                var current = _this.item[_this.property.name];
                _this.item[_this.property.name] = fileNames.concat(current);
            }
            return _this.item;
        }), mergeMap(function (item) { return _this.rest.save(item); }))
            .subscribe(function (saved) {
            //this.item = saved;
            image.loading = false;
            rest$.unsubscribe();
        }, function (error) {
            _this.snackBar.open('Upload failed', null, { duration: 3000 });
            image.loading = false;
            image.broken = true;
        });
    }; // uploadFile()
    ExtendzFileUploadComponent.prototype.handleFile = function (event) {
        var _this = this;
        var eventObj = event;
        var target = eventObj.target;
        var _loop_1 = function (index) {
            var file = target.files[index];
            var uploadingImage = new Image();
            uploadingImage.loading = true;
            var reader = new FileReader();
            reader.onload = function (event) {
                uploadingImage.url = reader.result;
                _this.images.unshift(uploadingImage);
                _this.uploadFile(file, uploadingImage);
            };
            reader.readAsDataURL(file);
        };
        // initialize the image list
        for (var index = 0; index < target.files.length; index++) {
            _loop_1(index);
        }
        if (1 === 1)
            return;
        /**
         * There should be at least one image selected.
         */
        if (target.files && target.files.length > 0) {
            // Create form data
            var formData = new FormData();
            var files = target.files;
            for (var i = 0, numFiles = files.length; i < numFiles; i++) {
                var file = files[i];
                formData.append(this.property.name, file);
            }
            var rest$_1 = this.rest.http
                .post(this.getUrl(), formData)
                .pipe(map(function (fileNames) {
                if (_this.property.relationShipType != RelationTypes.MULTIPLE) {
                    _this.item[_this.property.name] = fileNames[0];
                }
                else {
                    // Add existing
                    var current = _this.item[_this.property.name];
                    _this.item[_this.property.name] = fileNames.concat(current);
                }
                return _this.item;
            }), mergeMap(function (item) { return _this.rest.save(item); }))
                .subscribe(function (saved) {
                _this.item = saved;
                _this.updateImageList();
                rest$_1.unsubscribe();
            });
        }
    }; // handleFile()
    ExtendzFileUploadComponent.prototype.getUrl = function () {
        return this.item._links.self.href + '/' + this.property.name;
    }; // getUrl()
    ExtendzFileUploadComponent.prototype.getFileUrl = function (fileName) {
        return this.getUrl() + '/' + fileName;
    };
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", Object)
    ], ExtendzFileUploadComponent.prototype, "property", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", ObjectWithLinks)
    ], ExtendzFileUploadComponent.prototype, "item", void 0);
    ExtendzFileUploadComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-file-upload',
            template: "<div fxLayout=\"column\" fxLayoutAlign=\"center start\" fxLayoutGap=\"1vw\"> <mat-form-field fxFlex style=\"width: 100%\"> <input matInput disabled type=\"number\" [placeholder]=\"property?.name | camelCase\"> </mat-form-field> <div fxLayout=\"row\" fxLayout.xs=\"column\" fxLayoutWrap style=\"width: 100%\"> <!-- Add button --> <button fxFlex=\"30%\" fxFlex.xs=\"100%\" *ngIf=\"allowMultiple || images?.length === 0\" class=\"upload-button image-title\" type=\"button\" mat-button (click)=\"imgFileInput.click()\"> <mat-icon> <svg id=\"add\" viewBox=\"0 0 24 24\"> <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> <!-- [ngStyle]=\"{'background-image': 'url(' + url + ')'}\" --> <button mat-button fxFlex=\"30%\" fxFlex.xs=\"100%\" *ngFor=\"let image of images\" [matMenuTriggerFor]=\"appMenu\" extApiImage [url]=\"image.url\" class=\"upload-button\" type=\"button\" [ngClass]=\"{ 'gray': image.loading || image.broken}\"> <mat-icon *ngIf=\"!image.loading && !image.broken\"> <svg id=\"edit\" viewBox=\"0 0 24 24\"> <path d=\"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> <mat-icon *ngIf=\"image.broken\"> <svg id=\"broken_image\" viewBox=\"0 0 24 24\"> <path d=\"M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2\" fill=\"none\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z\" /> </svg> </mat-icon> <div fxLayoutAlign=\"center center\"> <mat-spinner *ngIf=\"image.loading\" color=\"accent\"></mat-spinner> </div> </button> <mat-menu #appMenu=\"matMenu\" yPosition=\"above\"> <!-- <button mat-menu-item (click)=\"imgFileInput.click()\">Edit</button> --> <button disabled mat-menu-item>Remove</button> </mat-menu> </div> <input hidden [multiple]=\"allowMultiple\" type=\"file\" #imgFileInput (change)=\"handleFile($event)\" /> <!-- <img *ngIf=\"imageFile\" [src]=\"imageFile\" [alt]=\"property.name\" style=\"width: 10vw;height: auto\"> --> </div>",
            styles: [".upload-button { background: rgba(0, 0, 0, 0.5); background-blend-mode: multiply; height: 30vh; color: white; background-size: cover; background-position: center center; margin: 1vw; } .gray { -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */ filter: grayscale(100%); } /*# sourceMappingURL=extendz-file-upload.component.css.map */ "]
        }),
        tslib_1.__metadata("design:paramtypes", [RestService, MatSnackBar])
    ], ExtendzFileUploadComponent);
    return ExtendzFileUploadComponent;
}()); // class
export { ExtendzFileUploadComponent };
//let reader = new FileReader();
//let file = event.target.files[0];
//reader.readAsDataURL(file);
//reader.onload = () => {};
//# sourceMappingURL=extendz-file-upload.component.js.map